import React, { useState } from 'react'
import './UF.css'

const MG = () => {
  const [service] = useState([
    { id: 1, uf: 'MG', city: 'Belo Horizonte', name: 'Serviço de Psicologia Aplicada (SPA/FAFICH/UFMG)', address: 'Sala 2062 da Faculdade de Filosofia e Ciências Humanas (segundo andar)', phone: '(31) 3409-5070', type: 'Clínica escola', info: 'spa@fafich.ufmg.br' },
    { id: 2, uf: 'MG', city: 'Juiz de Fora', name: 'Serviço de Psicologia Aplicada do Centro Universitário Estácio', address: 'Campus Rio Branco - Avenida Presidente João Goulart, 600, Cruzeiro do Sul', phone: '(32) 3249-3644', type: 'Clínica escola', info: '-' },
    //    { id: 2, uf: '', city: '', name: '', address: '', phone: '', type: '', info: '' },
    //    { id: 0, uf: '', city: '', name: '', address: '', phone: '', type: '', info: '' },
  ]);

  const [filter, setFilter] = useState('');

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filteredService = service.filter((item) =>
    item.city.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <div id="Board">
      <p id='showResult'>
        Aqui estão os serviços encontrados para o estado selecionado.
        <br />
        Se preferir, use o campo abaixo para filtrar os resultados por cidade.
        <br /><br />
        <input type="text" value={filter} onChange={handleFilterChange} placeholder="Digite o nome da cidade" />
      </p>
      <h3>Minas Gerais</h3>
      <p>
        <ul>
          {filteredService.map((item) => (
            <li key={item.id}>
              <strong>{item.name}</strong><br />
              <strong>UF: </strong>{item.uf}<br />
              <strong>Cidade: </strong>{item.city}<br />
              <strong>Endereço: </strong>{item.address}<br />
              <strong>Telefone: </strong>{item.phone}<br />
              <strong>Tipo: </strong>{item.type}<br />
              <strong>Mais Informações: </strong>{item.info}<br />
              <hr />
            </li>
          ))}
        </ul>
      </p>
    </div>
  )
}

export default MG
